import DashboardFieldList from './DashboardFieldList'
import AddField from './AddField'

export default function DashboardFieldEditor() {
  return <div>
    <DashboardFieldList />
    <AddField />
  </div>
}
